import React, {useEffect, useState} from 'react'
import {
    List,
    ListItem,
    Box,
    Text as TextTag,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import useLoqate from '../../hooks/use-loqate'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {getUrl} from '../../utils/cloudinary-utils'

const AddressSuggestions = ({
    suggestions,
    setSuggestions,
    setValue,
    clearErrors,
    onManualEntry,
    onAddressSelected,
    form
}) => {
    const loqateStyles = useMultiStyleConfig('LoqateStyles')
    const [history, setHistory] = useState([])

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                !event.target.closest('.react-loqate-default-list') &&
                !event.target.closest('.loqate-address-finder')
            ) {
                setSuggestions({})
                setHistory([])
            }
        }
        document.addEventListener('click', handleOutsideClick)
        return () => document.removeEventListener('click', handleOutsideClick)
    }, [])

    // Reset history when suggestions are cleared externally (e.g. field unmount)
    useEffect(() => {
        if (!suggestions?.length) {
            setHistory([])
        }
    }, [suggestions])

    const {getAddressSuggestion} = useLoqate()

    const handleBack = () => {
        const prev = history[history.length - 1]
        setHistory((h) => h.slice(0, -1))
        setSuggestions(prev)
    }

    const isInSubResults = history.length > 0

    if (!suggestions?.length) {
        return
    }
    return (
        <List className="react-loqate-default-list" {...loqateStyles.list}>
            <Box
                className="suggestions-header-box"
                {...loqateStyles.headerBox}
                onClick={
                    isInSubResults
                        ? handleBack
                        : () => {
                              setSuggestions({})
                              setHistory([])
                              if (onManualEntry) onManualEntry()
                          }
                }
            >
                {isInSubResults ? (
                    <TextTag {...loqateStyles.headerLink} className="suggestions-header-back">
                        <Image
                            className="back-icon"
                            src={getUrl('UIImages/images/redesign/right-small.svg')}
                            alt="back"
                            w="25px"
                            h="25px"
                        />
                        <FormattedMessage id="suggestions.back" defaultMessage="Go Back" />
                    </TextTag>
                ) : (
                    <>
                        <TextTag {...loqateStyles.headerText} className="suggestions-header-text">
                            <FormattedMessage
                                id="dont.see.address"
                                defaultMessage="Don't see your address?"
                            />
                        </TextTag>
                        <TextTag {...loqateStyles.headerLink} className="suggestions-header-link">
                            <FormattedMessage
                                id="enter.address.manually"
                                defaultMessage="Enter address manually"
                            />
                        </TextTag>
                    </>
                )}
            </Box>
            {suggestions.length &&
                suggestions.map(({Description, Highlight, Id, Text, Type}, index) => {
                    let subResults = ''
                    try {
                        const description = (Description.match(/(\d+)\s+Addresses$/i) || [])[1]
                        if (description) {
                            subResults = description + ' Results'
                        }
                    } catch (e) {
                        console.error('Unable to parse Description', e.message)
                    }
                    const type =
                        Type === 'Street' ||
                        Type === 'BuildingNumber' ||
                        Type === 'Apartment' ||
                        Type === 'Container'
                    const descriptionWithoutCount = Description?.replace(
                        /\s*-\s*\d+\s+Addresses$/i,
                        ''
                    )
                    return (
                        <ListItem
                            key={index}
                            onClick={() => {
                                if (Type !== 'Address') {
                                    setHistory((h) => [...h, suggestions])
                                } else if (onAddressSelected) {
                                    onAddressSelected()
                                }
                                getAddressSuggestion(
                                    {addressType: Type, addressId: Id, text: Text},
                                    setSuggestions,
                                    setValue,
                                    clearErrors,
                                    form
                                )
                            }}
                            className={
                                type
                                    ? 'react-loqate-list-item expand-street'
                                    : 'react-loqate-list-item street'
                            }
                            data-description={Description}
                            data-highlight={Highlight}
                            data-id={Id}
                            data-text={Text}
                            data-type={Type}
                            backgroundColor={index % 2 === 0 ? 'gray.50' : 'white'}
                            {...loqateStyles.listItem}
                        >
                            {Text + ' ' + descriptionWithoutCount}
                            {subResults && (
                                <Box
                                    className="sub-results-wrapper"
                                    {...loqateStyles.subResultsWrapper}
                                >
                                    <TextTag
                                        {...loqateStyles.subResultsText}
                                        className="sub-results-text"
                                    >
                                        {subResults}
                                    </TextTag>
                                    <Image
                                        className="arrow-icon"
                                        src={getUrl('UIImages/images/right-small-icon.svg')}
                                        alt="arrow"
                                        {...loqateStyles.arrowIcon}
                                    />
                                </Box>
                            )}
                        </ListItem>
                    )
                })}
        </List>
    )
}

AddressSuggestions.propTypes = {
    suggestions: PropTypes.any,
    setSuggestions: PropTypes.func,
    setValue: PropTypes.func,
    clearErrors: PropTypes.any,
    onManualEntry: PropTypes.func,
    onAddressSelected: PropTypes.func,
    form: PropTypes.object
}

export default AddressSuggestions
